import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import debounce from "lodash.debounce";
import update from "immutability-helper";
import { API } from "../../Services/api-services";
import profileImg from "../../assets/images/defaultmentorprofile.png";
import LogoEpicenter from "../../assets/images/epicenter_logo.png";
import { Form, Button } from "react-bootstrap";
import TextField from "@material-ui/core/TextField";
import { useHistory, useLocation } from "react-router-dom";
import { encrypt } from "../../utils/others";
import { auth } from "../../utils/auth";
import Axios from "axios";
import { requestPermission, onMessageListener } from "../../firebase";
import { alpha } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import InputBase from "@material-ui/core/InputBase";
import Badge from "@material-ui/core/Badge";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import MenuIcon from "@material-ui/icons/Menu";
import SearchIcon from "@material-ui/icons/Search";
import AccountCircle from "@material-ui/icons/AccountCircle";
import MailIcon from "@material-ui/icons/Mail";
import NotificationsIcon from "@material-ui/icons/Notifications";
import CloseIcon from "@material-ui/icons/Close";
import NotificationsOutlinedIcon from "@material-ui/icons/NotificationsNoneOutlined";
import HelpOutlineOutlinedIcon from "@material-ui/icons/HelpOutlineOutlined";
import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import AssignmentIndOutlinedIcon from "@material-ui/icons/AssignmentIndOutlined";
import TableChartOutlinedIcon from "@material-ui/icons/TableChartOutlined";
import PowerIcon from "@material-ui/icons/PowerSettingsNew";
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@material-ui/core";
import swal from "sweetalert";
import NotificationsNoneOutlinedIcon from "@material-ui/icons/NotificationsNoneOutlined";
import NotificationsDrawer from "./NotificationsDrawer";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import Switch from "@material-ui/core/Switch";
import { withStyles } from "@material-ui/core/styles";
import DisabledNotification from "./disabledNotification";
import NotificationPopup from "./NotificationPopup";
import ClassAlarmModal from "../ClassAlarm/ClassAlarmModal";
import { isSupported } from "firebase/messaging";
import InfoPopup from "./infoPopup";
import { useSelector, useDispatch } from "react-redux";
import { setNotificationData } from "../../Redux/Reducers/notifiactionSlice";
import { setFetchNotifications } from "../../Redux/Reducers/fetchNotificationSlice";
import { setAppDeviceData } from "../../Redux/Reducers/appDeviceSlice";
import SmsOutlinedIcon from "@material-ui/icons/SmsOutlined";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import { getUserId } from "../../utils/auth";
import LoopIcon from "@material-ui/icons/AllInclusive";
import { useChatUnread } from "../Chat/ChatUnreadContext";
import { fireEpicenterGtm } from "../../datalayers";

const BASE_URL = process.env.REACT_APP_EPICENTERAPI_BASE_URL;

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    height: "100vh",
    overflow: "auto",
  },
  drawer: {
    width: "300px",
  },
  drawerPaper: {
    width: "350px",
    background: "#FFFAF5",
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  notificationContainer: {
    display: "flex",
    flexDirection: "column",
    padding: "16px",
    background: "#FFFDFA",
    boxShadow: "0px 1px 2px 0px #FBE2C6",
    border: "1px solid #FDECD9",
    borderRadius: "8px",
    fontFamily: "Roboto",
    marginBottom: "24px",
  },
  profileContainer: {
    display: "flex",
    alignItems: "center",
    padding: "16px",
    background: "#FFFDFA",
    boxShadow: "0px 1px 2px 0px #FBE2C6",
    border: "1px solid #FDECD9",
    borderRadius: "8px",
    fontFamily: "Roboto",
    marginBottom: "20px",
  },
  profileImg: {
    maxWidth: "40px",
    maxHeight: "40px",
  },
  profileName: {
    color: "#3D3D3D",
    fontSize: "16px",
    fontWeight: "500",
    marginLeft: "8px",
  },
  menuConatainer: {
    display: "flex",
    alignItems: "center",
  },
  menuTitle: {
    color: "#FF712D",
    fontSize: "16px",
    fontWeight: "500",
  },
  logoutContainer: {
    display: "flex",
    alignItems: "center",
    padding: "10px 16px",
    background: "#FFD6D6",
    boxShadow: "0px 1px 2px 0px #FBE2C6",
    border: "1px solid #FFB8B8",
    borderRadius: "8px",
    fontFamily: "Roboto",
  },
  notificationHeader: {
    display: "flex",
    alignItems: "center",
    // justifyContent: "space-around",
    marginBottom: "20px",
  },
  notificationTitle: {
    color: "#3D3D3D",
    fontSize: "16px",
    fontWeight: "500",
    fontFamily: "Roboto",
    // marginLeft: "8px",
  },

  label: {
    fontSize: "18px",
    fontWeight: "500",
    color: "#3D3D3D",
    margin: "0px",
  },
  notificationDate: {
    color: "#A3A3A3",
    fontFamily: "Roboto",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
    marginTop: "10px",
    textAlign: "left",
  },
}));

const CustomSwitch = withStyles({
  switchBase: {
    color: "#FFDBC9",
    "&$checked": {
      color: "#FF702D",
    },
    "&$checked + $track": {
      backgroundColor: "#FFDBC9",
    },
  },
  checked: {},
  track: {
    backgroundColor: "#FFDBC9",
  },
})(Switch);

const NavBar = () => {
  const classes = useStyles();
  const location = useLocation();
  const emailRef = useRef();
  const dispatch = useDispatch();
  const fname = localStorage.getItem("FNAME");
  const lname = localStorage.getItem("LNAME");
  const profilePhoto = localStorage.getItem("profilePhoto");
  const passwordRef = useRef();
  const logoRef = useRef(null);
  const history = useHistory();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [isTokenFound, setTokenFound] = useState(false);
  const [token, setToken] = useState("");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isNotificationDrawerOpen, setIsNotificationDrawerOpen] =
    useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const [notificationsList, setNotificationsList] = useState([]);
  const [notificationIds, setNotificationsIds] = useState([]);
  const [notificationCount, setNotificationCount] = useState("");
  const [notificationStatus, setNotificationStatus] = useState(false);
  const [isRejected, setIsRejected] = useState(false);
  const [openNotificationPopup, setOpenNotificationPopup] = useState(false);
  const [infoPopup, setInfoPopup] = useState(false);
  const [infoDesc, setInfoDesc] = useState(false);
  // Pre-class attendance alarm payload forwarded from the native app.
  const [classAlarm, setClassAlarm] = useState(null);
  const [isShowNotificationToggle, setIsShowNotificationToggle] =
    useState(false);
  const storeNotifications = useSelector((state) => state.notifiactionData);
  const appDeviceData = useSelector((state) => state.appDeviceData);
  const userId = getUserId();
  const { unreadCount } = useChatUnread();

  const fetchNotificationsData = useSelector(
    (state) => state.fetchNotificationsData,
  );

  useEffect(() => {
    if (!window.ReactNativeWebView) {
      API.get("/fcm/token")
        .then((res) => {
          setToken(res?.data?.token);
          if (!res.data.token) {
            if (!getIsSupported()) {
              if (checkDevice()) {
                if (checkBrowserVersion() >= "16.4.0") {
                  if (!isAddedToHomeScreen()) {
                    setInfoDesc("Please add the application to home screen");
                    setInfoPopup(true);
                  } else {
                    setOpenNotificationPopup(true);
                    setIsShowNotificationToggle(true);
                  }
                } else {
                  setInfoDesc(
                    "Please upgrade the browser version for better experience",
                  );
                  setInfoPopup(true);
                }
              } else {
                setInfoDesc(
                  "Notofications are not supported for this browser. Please use any other browesr for better experience",
                );
                setInfoPopup(true);
              }
            } else {
              setIsShowNotificationToggle(true);
              setOpenNotificationPopup(true);
            }
          } else {
            setIsShowNotificationToggle(true);
            setNotificationStatus(true);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  }, []);

  useEffect(() => {
    if (storeNotifications) {
      setNotificationCount(storeNotifications?.notViewedCount);
      if (storeNotifications?.notifications?.length > 0) {
        setNotificationsList(storeNotifications?.notifications);
        const idList = storeNotifications?.notifications.map((item) => item.id);
        setNotificationsIds(idList);
      }
    }
  }, [storeNotifications]);

  /* functions related to React Native Mobile App */
  useEffect(() => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type: "routeChange", path: location.pathname }),
      );
    }
  }, [location.pathname]);

  // Tell native this component's message listener is mounted, so it can deliver
  // anything it queued while the web app was still loading (notably the class
  // alarm popup). routeChange was doing double duty for this, but it is tied to
  // location.pathname — it fires once on mount and then not again until the
  // mentor navigates, so anything native queued a moment too late was stranded.
  // This is a dedicated, repeatable signal.
  useEffect(() => {
    if (!window.ReactNativeWebView) return;
    const announce = () =>
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type: "webReady" }),
      );
    announce();
    // Native may still have been mid-init on the first announce (its own
    // pending-alarm lookup is async), so repeat a couple of times.
    const t1 = setTimeout(announce, 1500);
    const t2 = setTimeout(announce, 4000);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);

  const isDeviceLinked = () => {
    const token = localStorage.getItem("deviceToken");
    const linked = localStorage.getItem("linkedToken");
    if (token && linked) {
      const [linkedtoken, linkedUser] = linked.split("_delim_");
      if (linkedtoken == token && userId == linkedUser) {
        return true;
      }
    }
    return false;
  };

  const initDevicePermissions = (data) => {
    let permissions = data.token ? "permitted" : "denied";
    setToken(data.token);
    setTokenFound(permissions);
    setIsShowNotificationToggle(true);
    setIsRejected(false);
    dispatch(setFetchNotifications(true));
  };

  const linkDevice = async () => {
    const { token, linked } = appDeviceData;
    if (userId && token && linked === false) {
      API.put("/fcm/device", {
        token: localStorage.getItem("deviceToken"),
      })
        .then((res) => {
          setIsShowNotificationToggle(true);
          const { notifications } = res.data;
          const storageToken = localStorage.getItem("deviceToken");
          localStorage.setItem(
            "linkedToken",
            storageToken + "_delim_" + userId,
          );
          setNotificationStatus(notifications ? true : false);
          dispatch(setAppDeviceData({ token: token, linked: true }));
        })
        .catch((e) => {
          setIsShowNotificationToggle(true);
          dispatch(setAppDeviceData({ token: token, linked: "na" }));
          return false;
        });
    } else {
      console.log("link device failedddd");
    }
  };

  useEffect(() => {
    setTimeout(async () => {
      if (window.ReactNativeWebView) {
        setLoading(true);
        // if (isDeviceLinked()) initDevicePermissions(appDeviceData);
        linkDevice();
        setLoading(false);
      }
    }, 10);
  }, [appDeviceData]);

  useEffect(() => {
    const eventHandler = (event) => {
      try {
        const data = event.data;
        if (data && data.deviceTokenRefresh !== undefined) {
          localStorage.setItem("deviceToken", data.deviceTokenRefresh);
          dispatch(
            setAppDeviceData({ token: data.deviceTokenRefresh, linked: false }),
          );
        }
        if (data && data.devicePermission !== undefined) {
          localStorage.setItem("devicePermission", data.devicePermission);
          // setNotificationStatus(data.devicePermission);
        }
      } catch (err) {
        console.log("Error eventHandler", err);
      }
    };
    window.addEventListener("message", eventHandler);
    return () => {
      window.removeEventListener("message", eventHandler);
    };
  }, []);
  /* End : functions related to React Native Mobile App */

  const getIsSupported = async () => {
    try {
      const isSupportedBrowser = await isSupported();
      return isSupportedBrowser;
    } catch (err) {
      console.log(err);
    }
  };

  const checkDevice = () => {
    const userAgent = navigator.userAgent;
    if (/iPhone|iPad|iPod/i.test(userAgent)) {
      return true;
    } else {
      return false;
    }
  };

  const isAddedToHomeScreen = () => {
    if (
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone
    ) {
      return true;
    } else {
      return false;
    }
  };

  const checkBrowserVersion = () => {
    const userAgent = navigator.userAgent;
    let version;
    if (userAgent.indexOf("Safari") !== -1) {
      version = userAgent.match(/Version\/([\d.]+)/);

      if (version && version[1]) {
        return version[1];
      } else {
        console.log("Safari version information not found.");
      }
    }
  };

  const closeInfoPopup = () => {
    setInfoPopup(false);
  };

  const closeNotificationModal = () => {
    setOpenNotificationPopup(false);
  };

  const getNotifications = () => {
    let params = window.ReactNativeWebView
      ? "?token=" + localStorage.getItem("deviceToken")
      : "";
    API.get("/fcm/getNotifications" + params)
      .then((res) => {
        if (res && res?.data) {
          dispatch(setNotificationData(res.data));
          if (window.ReactNativeWebView) {
            const mobileData = {
              type: "notificationCount",
              count: res.data.notViewedCount,
            };

            window.ReactNativeWebView.postMessage(JSON.stringify(mobileData));
          }
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getNotifications();
  }, []);

  useEffect(() => {
    const handleMessage = (event) => {
      let data = event.data;
      // Native injects `window.postMessage(<object>, '*')`, but be tolerant of a
      // JSON string too — some WebView versions stringify it in transit, and a
      // silently unparsed payload looks exactly like "the message never came".
      if (typeof data === "string") {
        try {
          data = JSON.parse(data);
        } catch (e) {
          return;
        }
      }
      if (!data || typeof data !== "object") return;

      if (data.type === "navigateToChat" && window.ReactNativeWebView) {
        history.push("/chat");
        // A chat notification brought the mentor here, so the unread count is
        // stale. Same reasoning as showClassAlarm below: on a cold start the
        // mount-time fetch runs before the device token is in localStorage, so
        // it goes out as ?token=null and comes back empty. Native sends this
        // message only after that token exists.
        getNotifications();
        return;
      }
      if (data.type === "showClassAlarm") {
        // Native forwarded a pre-class attendance alarm — show the popup.
        // Deliberately NOT gated on window.ReactNativeWebView: the `type` is
        // specific enough on its own, and that global is injected by the
        // WebView asynchronously — gating on it means a message that arrives
        // fractionally too early is dropped with no trace.
        console.log("[ClassAlarm] showClassAlarm received", data.payload);
        setClassAlarm(data.payload || null);
        // The alarm is also recorded in the mentor's notification list, so pull
        // the unread count again to light up the bell. Needed here in addition
        // to native's refresh signal: when the alarm arrives while the app is
        // killed or backgrounded there is no WebView to receive that signal,
        // and by the time this message lands the mount-time fetch has already
        // run (and ran before the device token was in localStorage).
        getNotifications();
        return;
      }
      if (data.type === "registerVoipToken" && window.ReactNativeWebView) {
        console.log("[VoIP] Received registerVoipToken from native", data);
        console.log("user", userId);
        if (userId && data.token) {
          API.post("/mentor/voip-token", {
            token: data.token,
            platform: data.platform || "ios",
          })
            .then(() => {
              window.ReactNativeWebView.postMessage(
                JSON.stringify({ type: "voipTokenRegistered", token: data.token })
              );
            })
            .catch((e) =>
              console.log("[VoIP] token registration failed", e?.message)
            );
        }
        return;
      }
      if (data.notification !== undefined && window.ReactNativeWebView) {
        getNotifications();
      } else if (data.status !== undefined && window.ReactNativeWebView) {
        API.put("/fcm/device/status", {
          token: appDeviceData.token,
          notifications: data.status ? 1 : 0,
        })
          .then((res) => {
            localStorage.setItem("linkedToken", false);
            setNotificationStatus(data.status);
            handleSwitchSection("dashboard");
            setLoading(false);
          })
          .catch((e) => {
            setLoading(false);
          });
      } else if (
        data.disableToggle !== undefined &&
        window.ReactNativeWebView
      ) {
        setNotificationStatus(false);
      }
    };
    window.addEventListener("message", handleMessage);
    // Android's WebView has historically delivered injected messages to
    // `document` rather than `window`. Listening on both is the standard
    // defensive pattern and costs nothing — handleMessage ignores anything it
    // does not recognise, and a duplicate showClassAlarm is idempotent
    // (setClassAlarm with the same payload).
    document.addEventListener("message", handleMessage);
    return () => {
      document.removeEventListener("message", handleMessage);
      window.removeEventListener("message", handleMessage);
    };
  }, []);
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const toggleDrawer = (open) => {
    setIsDrawerOpen(open);
  };

  const toggleNotificationDrawer = (open) => {
    setIsNotificationDrawerOpen(open);
  };

  const logOut = () => {
    swal({
      title: "Logout",
      text: "Do you really want to logout?",
      buttons: ["No", "Yes, Logout"],
      closeOnClickOutside: false,
      closeOnEsc: false,
    }).then((logout) => {
      if (logout) {
        localStorage.removeItem("user");
        localStorage.removeItem("FNAME");
        localStorage.removeItem("LNAME");
        localStorage.removeItem("profilePhoto");
        localStorage.removeItem("workShift");
        window.location.replace("/");
      }
    });
  };

  const handleSwitchChangeForApp = (event) => {
    setLoading(true);
    const status = event.target.checked ? 1 : 0;

    if (status === 0) {
      API.put("/fcm/device/status", {
        token: appDeviceData.token,
        notifications: status,
      })
        .then((res) => {
          localStorage.setItem("linkedToken", false);
          setNotificationStatus(status ? true : false);
          setLoading(false);
        })
        .catch((e) => {
          setLoading(false);
        });
    } else {
      const mobileData = {
        type: "reqPermissions",
        payload: { status: status },
      };
      window.ReactNativeWebView.postMessage(JSON.stringify(mobileData));
    }
  };

  const handleSwitchChange = (event) => {
    if (window.ReactNativeWebView) {
      setNotificationStatus(event.target.checked);
      handleSwitchChangeForApp(event);
      return;
    }
    if (event.target.checked) {
      requestPermission(handleNotificationActivation);
    } else {
      if (token) {
        API.delete("/fcm/user", {
          token: appDeviceData.token,
        })
          .then((res) => {
            console.log("res", res);
          })
          .catch((e) => {
            console.log(e);
          });
      }
    }
    setNotificationStatus(event.target.checked);
  };

  const handleNotificationActivation = (status, token) => {
    // The one place the browser's allow/deny answer is unambiguous.
    fireEpicenterGtm("push_notifications_enabled", [
      status === "denied" ? "denied" : "allowed",
      "drawer",
    ]);
    if (status === "denied") {
      setIsRejected(true);
      setNotificationStatus(false);
    }
    setTokenFound(status);
  };

  const showContactusForm = () => {
    window.open(
      `${process.env.REACT_APP_SALESFORCE_SUPPORT_URL}/siteCaseCreation?id=${userId}`,
      "_blank",
    );
  };

  const handleNotificationsDrawer = () => {
    API.put("/fcm/markViewed", {
      notificationIds: notificationIds,
    })
      .then((res) => {
        setNotificationCount(null);
        if (window.ReactNativeWebView) {
          const mobileData = {
            type: "clearNotifications",
          };

          window.ReactNativeWebView.postMessage(JSON.stringify(mobileData));
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
    toggleNotificationDrawer(true);
  };

  const handleRejected = (status) => {
    setIsRejected(status);
  };

  const handleSwitchSection = (type) => {
    if (type === "dashboard") {
      history.push("/mentorDashboard");
    } else if (type === "profile") {
      history.push("/mentors");
    } else if (type === "loop") {
      history.push("/loop");
    } else if (type === "chat") {
      history.push("/chat");
    } else {
      history.push("/timetable");
    }
    toggleDrawer(false);
  };

  const handleChatwithus = () => {
    history.push("/chatwithus");
  };

  const handleHome = () => {
    if (!location.pathname.includes("mentorDashboard"))
      history.push("/mentorDashboard");
  };

  const handleActions = (notification) => {
    if (notification && notification?.type.includes("loop")) {
      toggleNotificationDrawer(false);
      history.push("/loop");
    }
  };

  const menuId = "primary-search-account-menu";
  const renderNotificationDrawer = (
    <Drawer
      anchor="left"
      open={isNotificationDrawerOpen}
      onClose={() => setIsNotificationDrawerOpen(false)}
      className={classes.drawer}
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <Grid container style={{ padding: "0px 16px" }}>
        <Grid item xs={12} className={classes.notificationHeader}>
          <IconButton onClick={() => setIsNotificationDrawerOpen(false)}>
            <NotificationsOutlinedIcon
              style={{
                fontSize: "24px",
                color: "#3D3D3D",
                fontWeight: "500",
              }}
            />
          </IconButton>
          <div className={classes.notificationTitle}>Notifications</div>
          <IconButton
            onClick={() => setIsNotificationDrawerOpen(false)}
            style={{ marginLeft: "auto" }}
          >
            <CloseIcon
              style={{
                fontSize: "24px",
                color: "#3D3D3D",
                fontWeight: "500",
              }}
            />
          </IconButton>
        </Grid>
        <Grid item xs={12}>
          {notificationsList.length > 0 ? (
            notificationsList.map((notification) => (
              <div
                className={classes.notificationContainer}
                onClick={() => {
                  handleActions(notification);
                }}
              >
                <div>{notification.notificationContent.body}</div>
                <div className={classes.notificationDate}>
                  {notification.sentDate}
                </div>
              </div>
            ))
          ) : (
            <div className={classes.profileContainer}>
              No new pending notifications
            </div>
          )}
        </Grid>
      </Grid>
    </Drawer>
  );

  return (
    <div className={classes.grow}>
      {classAlarm && (
        <ClassAlarmModal
          payload={classAlarm}
          // mentorId comes from the backend via the app payload, so analytics
          // attribute the alarm to the mentor it was actually raised against.
          // Falls back to the logged-in user only if an older app build (which
          // does not forward the field) is talking to this web version.
          mentorId={classAlarm?.mentorId || userId}
          onClose={() => setClassAlarm(null)}
        />
      )}
      {/* {isNotificationDrawerOpen && (
        <NotificationsDrawer
          isNotificationDrawerOpen={isNotificationDrawerOpen}
          toggleNotificationDrawer={toggleNotificationDrawer}
          notificationsList={notificationsList}
        />
      )} */}
      {isRejected && (
        <DisabledNotification
          open={isRejected}
          closeModalHandler={handleRejected}
        />
      )}
      <AppBar
        position="relative"
        style={{ color: "#FF712D", backgroundColor: "#fff" }}
      >
        <Toolbar>
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="open drawer"
            onClick={() => toggleDrawer(true)}
          >
            <MenuIcon />
          </IconButton>

          <Drawer
            anchor="left"
            open={isDrawerOpen}
            onClose={() => toggleDrawer(false)}
            className={classes.drawer}
            classes={{
              paper: classes.drawerPaper,
            }}
          >
            <div className={classes.drawerHeader}>
              <IconButton
                onClick={() => toggleDrawer(false)}
                style={{ float: "right" }}
              >
                <CloseIcon
                  style={{
                    fontSize: "24px",
                    color: "#3D3D3D",
                    fontWeight: "500",
                  }}
                />
              </IconButton>
            </div>
            {/* <Divider /> */}
            <Grid container style={{ padding: "0px 16px" }}>
              <Grid
                item
                xs={12}
                style={{ margin: "40px 0px", padding: "0px 16px" }}
              >
                <img
                  src={LogoEpicenter}
                  alt="epicenter_logo"
                  style={{ maxWidth: "150px", maxHeight: "40px" }}
                />
              </Grid>
              <Grid item xs={12} className={classes.profileContainer}>
                <img
                  src={profileImg}
                  alt="profileImg"
                  className={classes.profileImg}
                />
                <div className={classes.profileName}>
                  Hello {fname} {lname}
                </div>
              </Grid>
              <Grid container className={classes.profileContainer}>
                <Grid
                  item
                  xs={12}
                  className={classes.menuConatainer}
                  onClick={() => handleSwitchSection("dashboard")}
                >
                  <IconButton
                    onClick={() => handleSwitchSection("dashboard")}
                  // style={{ float: "right" }}
                  >
                    <DashboardOutlinedIcon
                      style={{
                        fontSize: "24px",
                        color: "#FF712D",
                        fontWeight: "500",
                      }}
                    />
                  </IconButton>
                  <div
                    className={classes.menuTitle}
                    onClick={() => handleSwitchSection("dashboard")}
                  >
                    Dashboard
                  </div>
                </Grid>
                <Grid item xs={11} className={classes.menuConatainer}>
                  <Divider
                    variant="middle"
                    style={{ color: "#FFD2C2", width: "100%" }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  className={classes.menuConatainer}
                  onClick={() => handleSwitchSection("timeTable")}
                >
                  <IconButton
                    onClick={() => handleSwitchSection("timeTable")}
                  // style={{ float: "right" }}
                  >
                    <TableChartOutlinedIcon
                      style={{
                        fontSize: "24px",
                        color: "#FF712D",
                        fontWeight: "500",
                      }}
                    />
                  </IconButton>
                  <div
                    className={classes.menuTitle}
                    onClick={() => handleSwitchSection("timeTable")}
                  >
                    Time Table
                  </div>
                </Grid>
                <Grid item xs={11} className={classes.menuConatainer}>
                  <Divider
                    variant="middle"
                    style={{ color: "#FFD2C2", width: "100%" }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  className={classes.menuConatainer}
                  onClick={() => handleSwitchSection("loop")}
                >
                  <IconButton
                    onClick={() => handleSwitchSection("loop")}
                  // style={{ float: "right" }}
                  >
                    <LoopIcon
                      style={{
                        fontSize: "24px",
                        color: "#FF712D",
                        fontWeight: "500",
                      }}
                    />
                  </IconButton>
                  <div
                    className={classes.menuTitle}
                    onClick={() => handleSwitchSection("loop")}
                  >
                    Loop
                  </div>
                </Grid>
                <Grid item xs={11} className={classes.menuConatainer}>
                  <Divider
                    variant="middle"
                    style={{ color: "#FFD2C2", width: "100%" }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  className={classes.menuConatainer}
                  onClick={() => handleSwitchSection("chat")}
                >
                  <IconButton onClick={() => handleSwitchSection("chat")}>
                    <Badge
                      badgeContent={unreadCount > 0 ? unreadCount : 0}
                      color="error"
                      overlap="circle"
                      invisible={!unreadCount}
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                    >
                      <ChatBubbleOutlineIcon
                        style={{
                          fontSize: "24px",
                          color: "#FF712D",
                          fontWeight: "500",
                        }}
                      />
                    </Badge>
                  </IconButton>
                  <div
                    className={classes.menuTitle}
                    onClick={() => handleSwitchSection("chat")}
                  >
                    Chat
                  </div>
                </Grid>
                <Grid item xs={11} className={classes.menuConatainer}>
                  <Divider
                    variant="middle"
                    style={{ color: "#FFD2C2", width: "100%" }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  className={classes.menuConatainer}
                  onClick={() => handleSwitchSection("profile")}
                >
                  <IconButton
                    onClick={() => handleSwitchSection("profile")}
                  // style={{ float: "right" }}
                  >
                    <AssignmentIndOutlinedIcon
                      style={{
                        fontSize: "24px",
                        color: "#FF712D",
                        fontWeight: "500",
                      }}
                    />
                  </IconButton>
                  <div
                    className={classes.menuTitle}
                    onClick={() => handleSwitchSection("profile")}
                  >
                    Profile
                  </div>
                </Grid>
                <Grid item xs={11} className={classes.menuConatainer}>
                  <Divider
                    variant="middle"
                    style={{ color: "#FFD2C2", width: "100%" }}
                  />
                </Grid>
                {/* <Grid item xs={10} className={classes.menuConatainer}>
                
                  <Divider
                    style={{ color: "#FFD2C2", border: "1px solid #FFD2C2" }}
                  />
                </Grid> */}
                <Grid
                  item
                  xs={12}
                  className={classes.menuConatainer}
                  onClick={showContactusForm}
                >
                  <IconButton
                    onClick={showContactusForm}
                  // style={{ float: "right" }}
                  >
                    <HelpOutlineOutlinedIcon
                      style={{
                        fontSize: "24px",
                        color: "#FF712D",
                        fontWeight: "500",
                      }}
                    />
                  </IconButton>
                  <div
                    className={classes.menuTitle}
                    onClick={showContactusForm}
                  >
                    Help
                  </div>
                </Grid>
              </Grid>
              {isShowNotificationToggle && (
                <Grid
                  item
                  xs={12}
                  className={classes.profileContainer}
                  style={{ marginBottom: "20px" }}
                >
                  <FormControl component="fieldset">
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <CustomSwitch
                            checked={notificationStatus}
                            onChange={handleSwitchChange}
                            name="notificationStatus"
                          />
                        }
                        label="Enable Push Notifications"
                        labelPlacement="start"
                        classes={{ label: classes.label }}
                      />
                    </FormGroup>
                  </FormControl>
                  {/* <IconButton
                  onClick={handleNotifications}
                  // style={{ float: "right" }}
                >
                  <PowerIcon
                    style={{
                      fontSize: "24px",
                      color: "#FF712D",
                      fontWeight: "500",
                    }}
                  />
                </IconButton>
                <div className={classes.menuTitle}>Enable Notifications</div> */}
                </Grid>
              )}
              <Grid
                item
                xs={12}
                className={classes.logoutContainer}
                onClick={logOut}
              >
                <IconButton
                // style={{ float: "right" }}
                >
                  <PowerIcon
                    style={{
                      fontSize: "24px",
                      color: "#FF712D",
                      fontWeight: "500",
                    }}
                  />
                </IconButton>
                <div className={classes.menuTitle}>Logout</div>
              </Grid>
            </Grid>
          </Drawer>

          <Typography
            className={classes.title}
            style={{ color: "#3D3D3D" }}
            variant="h6"
            noWrap
          >
            {location.pathname.includes("refer-mentors") ||
              location.pathname.includes("referral")
              ? "Referral"
              : location.pathname.includes("timetable")
                ? "Time Table"
                : location.pathname.includes("mentorDashboard")
                  ? "Dashboard"
                  : location.pathname.includes("loop")
                    ? "Loop"
                    : location.pathname.includes("payout")
                      ? "Payout"
                      : location.pathname.includes("chat")
                        ? "Chat"
                        : "Profile"}
          </Typography>
          <div className={classes.grow} />
          <IconButton
            aria-label="show 17 new notifications"
            color="inherit"
            onClick={handleHome}
            style={{ padding: "8px" }}
          >
            <HomeOutlinedIcon />
          </IconButton>
          <div style={{ display: "flex", alignItems: "center" }}>
            <IconButton
              aria-label="show 17 new notifications"
              color="inherit"
              onClick={handleNotificationsDrawer}
              style={{ padding: "8px" }}
            >
              {notificationCount > 0 ? (
                <Badge badgeContent={notificationCount} color="secondary">
                  <NotificationsIcon />
                </Badge>
              ) : (
                <NotificationsNoneOutlinedIcon />
              )}
            </IconButton>

            <IconButton
              aria-label="show 4 new mails"
              color="inherit"
              onClick={showContactusForm}
              style={{ padding: "8px" }}
            >
              <HelpOutlineOutlinedIcon />
            </IconButton>
            {/* <div style={{ padding: "8px" }}>
              {profilePhoto ? (
                <img
                  src={profilePhoto}
                  alt=""
                  height="20px"
                  width="20px"
                  style={{ borderRadius: "50%" }}
                />
              ) : (
                <IconButton
                  edge="end"
                  aria-label="account of current user"
                  aria-controls={menuId}
                  aria-haspopup="true"
                  onClick={handleProfileMenuOpen}
                  color="inherit"
                >
                  <AccountCircle />
                </IconButton>
              )}
            </div> */}

            {/* {window.ReactNativeWebView && (
              <div style={{ padding: "8px" }}>
                <IconButton
                  aria-label="show 17 new notifications"
                  color="inherit"
                  onClick={handleChatwithus}
                  style={{ padding: "8px" }}
                >
                  <Badge badgeContent={0} color="secondary">
                    <SmsOutlinedIcon />
                  </Badge>
                </IconButton>
              </div>
            )} */}
          </div>
        </Toolbar>
      </AppBar>
      {renderNotificationDrawer}
      {openNotificationPopup && (
        <NotificationPopup
          open={openNotificationPopup}
          closeModalHandler={closeNotificationModal}
          toggleDrawer={toggleDrawer}
        />
      )}
      {infoPopup && (
        <InfoPopup
          open={infoPopup}
          closeModalHandler={closeInfoPopup}
          infoDesc={infoDesc}
        />
      )}
    </div>
  );
};

export default NavBar;
